import { useEffect } from "react";

// AIDEV-NOTE: Google Tag Manager integration with ad-blocker resilience
// Uses server-side proxy to bypass ad blockers and enable cross-domain tracking
// from Framer website to app. GTM container configured with auth/preview for environment separation.

declare global {
    interface Window {
        dataLayer: Array<Record<string, unknown>>;
    }
}

export function GoogleTagManager() {
    useEffect(() => {
        const gtmId = window.env?.GTM_CONTAINER_ID;
        const gtmAuth = window.env?.GTM_AUTH;
        const gtmPreview = window.env?.GTM_PREVIEW;

        // Only load GTM if container ID is configured
        if (!gtmId) {
            return;
        }

        // Initialize dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "gtm.start": new Date().getTime(),
            event: "gtm.js",
        });

        // Load GTM script from our proxy endpoint
        const script = document.createElement("script");
        script.async = true;

        // AIDEV-NOTE: Use /attr proxy endpoint (innocuous name) instead of googletagmanager.com to bypass ad blockers
        let src = `/attr?id=${gtmId}`;
        if (gtmAuth && gtmPreview) {
            // Add auth and preview params for environment-specific container versions
            src += `&gtm_auth=${gtmAuth}&gtm_preview=${gtmPreview}&gtm_cookies_win=x`;
        }

        script.src = src;
        script.setAttribute("data-source", "gtm");
        document.head.appendChild(script);

        return () => {
            // Cleanup script on unmount
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        };
    }, []);

    return null;
}
